export default __webpack_public_path__ + "cc2d617f7bfb39ce0d0b294e5695930d.webp";